import { createSlice, createAsyncThunk, Action } from '@reduxjs/toolkit';
import { ping } from './healthAPI';

export interface PingMessage {
  message: string
}

export interface HealthState {
  value: string | undefined;
  status: 'idle' | 'loading' | 'failed'
  pingMessage: PingMessage | undefined
  errorMessage: string | undefined;
}

const initialState: HealthState = {
  value: undefined,
  status: 'idle',
  pingMessage: undefined,
  errorMessage: undefined
};

export const pingAsync = createAsyncThunk(
  'health/ping',
  async ({ apiToken }: 
             { apiToken: string }) => {
    const response = await ping(apiToken);
    return response.data;
  }
);

export const healthSlice = createSlice({
  name: 'health',
  initialState,
  reducers: {
    dummy: (_, __: Action) => {
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(pingAsync.pending, (state) => {
        state.status = 'loading';
        state.pingMessage = undefined;
      })
      .addCase(pingAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.pingMessage = action.payload;
      })
      .addCase(pingAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.errorMessage = action.error.message;
        state.pingMessage = undefined;
      });
  }
});

export default healthSlice.reducer;

